var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRightBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74408 16.4239C7.41864 16.0985 7.41864 15.5708 7.74408 15.2454L12.9882 10.0013L7.74408 4.75722C7.41864 4.43179 7.41864 3.90415 7.74408 3.57871C8.06951 3.25328 8.59715 3.25328 8.92259 3.57871L14.7559 9.41205C15.0814 9.73748 15.0814 10.2651 14.7559 10.5906L8.92259 16.4239C8.59715 16.7493 8.06951 16.7493 7.74408 16.4239Z",
    fill: "#146EB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightBlue);
export default __webpack_public_path__ + "static/media/chevron-right-blue.360763dcd0315287701be7f8e003c88d.svg";
export { ForwardRef as ReactComponent };